/**
 * Full-screen textured quad shader
 */

const EdgeDetectShader = {

	name: 'EdgeDetectShader',

	uniforms: {

		'tDiffuse': { value: null },
		'opacity': { value: 1.0 },
        'resolution': { type: 'v2', value: null},
        'color': { type: 'v3', value: null},
        'fillcolor': { type: 'v3', value: null},
        'modeloverride': {type: 'b', value: null}

	},

	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`
        uniform vec2 resolution;

		uniform float opacity;

		uniform sampler2D tDiffuse;

        uniform vec3 color;
        uniform vec3 fillcolor;

        uniform bool modeloverride;

		varying vec2 vUv;

        vec2 uv;

        vec3 rgb2hsv(vec3 c)
        {
            vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
            vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
            vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));
        
            float d = q.x - min(q.w, q.y);
            float e = 1.0e-10;
            return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
        }
        
        vec3 hsv2rgb(vec3 c)
        {
            vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
            vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
            return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
        }

        vec4 edgeDetect(vec4 texel)
        {
          
            float o = 0.1;
            float p = 22.1;
            float q = 0.0;

            float unitx = 1.0 / resolution.x;
            float unity = 1.0 / resolution.y;

            vec4 col11 = texture2D(tDiffuse, uv + vec2(-unitx, -unity));
            vec4 col12 = texture2D(tDiffuse, uv + vec2(0.0, -unity));
            vec4 col13 = texture2D(tDiffuse, uv + vec2(unitx, -unity));

            vec4 col21 = texture2D(tDiffuse, uv + vec2(-unitx, 0.0));
            vec4 col22 = texture2D(tDiffuse, uv + vec2(0.0, 0.0));
            vec4 col23 = texture2D(tDiffuse, uv + vec2(unitx, 0.0));

            vec4 col31 = texture2D(tDiffuse, uv + vec2(-unitx, unity));
            vec4 col32 = texture2D(tDiffuse, uv + vec2(0.0, unity));
            vec4 col33 = texture2D(tDiffuse, uv + vec2(unitx, unity));

            vec4 x = col11 * -o + col12 * -p + col13 * -o + col31 * o + col32 * p + col33 * o + col22 * q;
            vec4 y = col11 * -o + col21 * -p + col31 * -o + col13 * o + col23 * p + col33 * o + col22 * q;

            vec4 baaa = vec4(fillcolor.r / 255.0,fillcolor.g / 255.0,fillcolor.b / 255.0,0.0);
            if (modeloverride == false)
            {
              baaa = texel;
              return vec4(abs(y.rgb) * 0.5 + abs(x.rgb) * 0.5, 1.) * vec4(color.r / 255.0,color.g / 255.0,color.b / 255.0, 1.0) + baaa;
            }
            else
            {
              vec3 hsv = rgb2hsv(vec3(abs(y.rgb) * 0.5 + abs(x.rgb) * 0.5));
              vec3 sat = hsv2rgb(vec3(hsv.r, 0.0, hsv.b));
              return vec4(sat.rgb, 1.0) * vec4(color.r / 255.0,color.g / 255.0,color.b / 255.0, 1.0) + baaa;
            }

        }


		void main() {
            uv = vUv;
			vec4 texel = texture2D( tDiffuse, uv );

            if (texel.a > 0.01)
            {
              gl_FragColor = edgeDetect(texel);
            }
            else
            {
              gl_FragColor = vec4(0.0,0.0,0.0,0.0);
            }

		}`

};
